import { Target, Eye, GitBranch, Scale, GraduationCap, Map, Sprout, ShieldCheck } from "lucide-react";

const PILLARS = [
  { icon: Target, title: "Mission", body: "Unite all karate stakeholders under one transparent national platform and elevate Indian karate to global benchmarks." },
  { icon: Eye, title: "Vision", body: "A nation where every aspiring karateka has access to certified coaching, fair competition, and a clear performance pathway." },
  { icon: GitBranch, title: "Objectives", body: "Standardise grading, build the national registry, and run a world-class championship calendar across the three disciplines." },
  { icon: Scale, title: "Transparency", body: "Public databases of athletes, coaches and officials — open national registry maintained by the federation." },
  { icon: ShieldCheck, title: "Governance", body: "Federated structure — State and District units governed under a single national rulebook and Code of Conduct." },
  { icon: GraduationCap, title: "Education", body: "Continuous coach and referee education, technical seminars, and the National Master Course programme." },
  { icon: Sprout, title: "Development", body: "Scholarships, talent identification camps, and dedicated pathways for women, youth and para athletes." },
  { icon: Map, title: "National Expansion", body: "28 State units, 312 District units and growing — one platform, one federation, one India." },
];

export default function FederationIntro() {
  return (
    <section data-testid="federation-intro" className="section-spacing bg-white">
      <div className="nkf-container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 sm:gap-10">
          <div className="lg:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.3em] text-nkf-red font-semibold">About the Federation</div>
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-nkf-blue mt-2 leading-tight">
              One Nation. <br /> One Federation. <br /> <span className="text-nkf-red">One Karate.</span>
            </h2>
            <p className="text-slate-600 mt-4 sm:mt-5 text-sm sm:text-base leading-relaxed">
              The National Karate Federation – NKF Bharat is the apex governing body for Traditional, Semi-Contact and Full-Contact Karate in India. Established to unify the discipline under a single transparent national structure, the federation oversees affiliation, certification, competition, and athlete development across all states and union territories.
            </p>
            <div className="mt-5 sm:mt-6 inline-flex items-start gap-3 bg-nkf-gold/10 border border-nkf-gold/30 px-4 py-3 rounded">
              <ShieldCheck className="h-5 w-5 text-nkf-blue mt-0.5 shrink-0" />
              <div className="text-sm text-nkf-blue">
                <span className="font-semibold">Recognised by</span> ITKF • IAKS • ICSSPE • TAFISA • UKF
              </div>
            </div>
          </div>
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 items-stretch">
            {PILLARS.map((p) => {
              const Icon = p.icon;
              return (
                <div key={p.title} className="federation-card bg-white border border-slate-200 rounded-md p-5 hover:border-nkf-blue/40 flex flex-col h-full">
                  <div className="flex items-center gap-3">
                    <div className="h-10 w-10 rounded bg-nkf-blue/5 border border-nkf-blue/15 flex items-center justify-center">
                      <Icon className="h-5 w-5 text-nkf-blue" />
                    </div>
                    <h3 className="font-display text-lg text-nkf-blue">{p.title}</h3>
                  </div>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed flex-1">{p.body}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
